import React from 'react';
import ScrollToBottom from 'react-scroll-to-bottom';

import './TextContainer.css'

const TextContainer = ({users,room}) => {
    return (
      <ScrollToBottom>
        <div className="list">
            <h2 className="listHeading">People in the Room '{room}'</h2>
            {
                users.map((user,i) =>  <h3 key={i} className="listText">* {user.name}</h3>)
            }
        </div>
      </ScrollToBottom>
    )
}

export default TextContainer;